var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail34-template',{attrs:{"board-ids":[114, 234, 235, 236, 237],"field-code":"public-transportation","com-group-list":_vm.comGroupList,"graph1-title":"전체 (공중교통수단) 관리 현황","graph2-title":"월별 (공중교통수단) 관리 현황","graph3-title":"기간별 (공중교통수단) 관리 현황","button-board":"시설물 관리","field-label":"공중교통수단","field-category-label":"구분"}})
}
var staticRenderFns = []

export { render, staticRenderFns }